/*
 * pp-customer-rail.js — el botón del menú lateral, SOLO donde no hay ratón.
 *
 * Con ratón (la gran mayoría en escritorio) el rail se abre al asomarse y el
 * botón está oculto por CSS: «lo de las tres líneas en desktop, quítamelo»
 * (24-sep-2026). Este archivo se apaga solo en ese caso.
 *
 * Queda vivo para una TABLETA ANCHA (>=768px sin hover): ahí el :hover no
 * existe y sin botón no habría forma de ver las etiquetas. El ancho lo manda
 * data-pp-rail en <html> ('cerrado' | 'abierto') y el CSS hace el resto.
 *
 * Abajo de 768px el rail es display:none y navega pp-mobile-tab-bar-account.
 */
(function () {
  var LLAVE = 'pp-rail';
  var raiz = document.documentElement;
  var boton = document.querySelector('[data-pp-rail-toggle]');
  if (!boton) return;

  // Con ratón el botón está oculto por CSS y asomarse ya abre el rail. Un
  // 'abierto' guardado de antes lo dejaría abierto para siempre, sin botón
  // con el cual cerrarlo. Se limpia al cargar: donde hay hover, el estado
  // guardado no significa nada.
  var hayRaton = typeof window.matchMedia === 'function' &&
    window.matchMedia('(hover: hover)').matches;
  if (hayRaton) {
    raiz.setAttribute('data-pp-rail', 'cerrado');
    try {
      localStorage.removeItem(LLAVE);
    } catch (e) {}
    return;
  }

  function estaAbierto() {
    return raiz.getAttribute('data-pp-rail') === 'abierto';
  }

  function sincronizar() {
    var abierto = estaAbierto();
    var etiqueta = abierto
      ? boton.getAttribute('data-label-cerrar')
      : boton.getAttribute('data-label-abrir');
    boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    if (etiqueta) {
      boton.setAttribute('aria-label', etiqueta);
      boton.setAttribute('title', etiqueta);
    }
  }

  function poner(estado) {
    raiz.setAttribute('data-pp-rail', estado);
    // Modo privado / cookies bloqueadas: el rail funciona igual, solo no
    // se acuerda en la siguiente página.
    try {
      localStorage.setItem(LLAVE, estado);
    } catch (e) {}
    sincronizar();
  }

  boton.addEventListener('click', function () {
    poner(estaAbierto() ? 'cerrado' : 'abierto');
  });

  // Abierto el rail TAPA el contenido (no lo empuja: esa era la queja). Por
  // eso necesita las dos salidas de cualquier overlay — si no, el cliente se
  // queda con media pantalla cubierta y sin saber cómo quitarla.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && estaAbierto()) {
      poner('cerrado');
      boton.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (!estaAbierto()) return;
    var rail = document.querySelector('.pp-rail');
    if (rail && !rail.contains(e.target)) poner('cerrado');
  });

  sincronizar();
})();
